export const notificationsDisabledHeaderButton = "jhgKHe";
export const notificationsHeaderButton = "fJ8Y3";
export const notificationsHeaderButtonWithCount = "syZrge";
export const settingsHeaderButton = "QucxFc";
export const myDayHeaderButton = "r9nXUd";
export const premiumHeaderButton = "EeNaHe";
export const manageSubscriptionHeaderButton = "JDC6h";
export const buyMicrosoft365HeaderButton = "trNk2d";
export const upgradeMicrosoft365HeaderButton = "PbEtv";
export const rewardsHeaderButton = "Zy7GYc";
export const teamsChatHeaderButton = "r6XSyb";
export const syncHeaderButton = "ilCtud";
export const syncHeaderButtonTooltip = "ph6VOd";
export const undoHeaderButton = "dq$Iic";
export const undoHeaderButtonTooltip = "GWBhIc";
export const updateAvailableHeaderButton = "DZ_AMb";
export const updateAvailableHeaderButtonTooltip = "sBGREd";
export const applyingUpdatesHeaderButton = "jY4CUd";
export const applyingUpdatesHeaderButtonTooltip = "SJ0CYd";
export const teamsChatHeaderButtonWithCount = "eu3b4b";
export default {notificationsDisabledHeaderButton,notificationsHeaderButton,notificationsHeaderButtonWithCount,settingsHeaderButton,myDayHeaderButton,premiumHeaderButton,manageSubscriptionHeaderButton,buyMicrosoft365HeaderButton,upgradeMicrosoft365HeaderButton,rewardsHeaderButton,teamsChatHeaderButton,syncHeaderButton,syncHeaderButtonTooltip,undoHeaderButton,undoHeaderButtonTooltip,updateAvailableHeaderButton,updateAvailableHeaderButtonTooltip,applyingUpdatesHeaderButton,applyingUpdatesHeaderButtonTooltip,teamsChatHeaderButtonWithCount};